import gql from 'graphql-tag';

export default gql`
fragment UrlAliasAllData on UrlAlias {
    id
    source_url
    target_url
    created_at
    updated_at
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UrlAliasAllData.ts